import styled from 'styled-components';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { useState } from 'react';
import { AddCoupangApiStoreInfoModal } from './modals/add-coupang-api-store-info-modal';
import { useCoupangApiStoreInfoValueContextHook } from '../../contexts/CoupangApiStoreInfoContext';
import { useSelectedCoupangApiStoreInfosActionsContextHook, useSelectedCoupangApiStoreInfosValueContextHook } from '../../contexts/SelectedCoupangApiStoreInfosContext';
import { EditCoupangApiStoreInfoModal } from './modals/edit-coupang-api-store-info-modal';

const ScContainer = styled.div`
    padding: 10px;
`;

const ScTitle = {
    Container: styled.div`
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    `,
    Name: styled.h2`
      font-size: 24px;
      font-weight: 600;
      color: #333;
    `,
    AddButton: styled(CustomBlockButton)`
      width: auto;
      height: auto;
      padding: 10px 16px;
      font-size: 14px;
      font-weight: 600;
      background-color: #333;
      color: white;
      border: none;
      border-radius: 3px;
    `,
}

const ScStoreList = {
    Container: styled.div`
      display: grid;
      gap: 10px;
    `,
    Item: styled.div`
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      background-color: white;
      border-radius: 3px;
      border: 1px solid #efefef;
      transition: background-color 0.3s ease;
  
      &.selected{
        background-color: #dbefff;
      }
    `,
    ItemName: styled.div`
      font-size: 16px;
      font-weight: 600;
      color: #333;
    `,
    ItemEditButton: styled(CustomBlockButton)`
      width: auto;
      height: auto;
      padding: 8px 12px;
      font-size: 14px;
      font-weight: 600;
      background-color: #333;
      color: white;
      border: none;
      border-radius: 3px;
    `,
}

export function WegetMainCoupangApiStoreList(props) {
    const coupangApiStoreInfosValueContextHook = useCoupangApiStoreInfoValueContextHook();
    const [addModalOpen, setAddModalOpen] = useState(false);
    return (
        <>
            <ScContainer>
                <ScTitle.Container>
                    <ScTitle.Name>
                        <span style={{ color: '#E94B22' }}>쿠팡</span> 관리 목록
                    </ScTitle.Name>
                    <ScTitle.AddButton
                        type='button'
                        onClick={() => setAddModalOpen(true)}
                    >
                        추가
                    </ScTitle.AddButton>
                </ScTitle.Container>
                <ScStoreList.Container>
                    {coupangApiStoreInfosValueContextHook?.coupangApiStoreInfos?.map((storeInfo, index) => {
                        return (
                            <StoreInfoItem
                                key={storeInfo?.id}
                                coupangApiStoreInfo={storeInfo}
                                index={index}
                            />
                        )
                    })}
                </ScStoreList.Container>
            </ScContainer>

            {addModalOpen &&
                <AddCoupangApiStoreInfoModal
                    open={addModalOpen}
                    onClose={() => setAddModalOpen(false)}
                />
            }
        </>
    );
}

function StoreInfoItem({
    coupangApiStoreInfo,
    index,
}) {
    const selectedCoupangApiStoreInfosValueContextHook = useSelectedCoupangApiStoreInfosValueContextHook();
    const selectedCoupangApiStoreInfosActionsContextHook = useSelectedCoupangApiStoreInfosActionsContextHook();

    const [editMoalOpen, setEditModalOpen] = useState(false);

    const isSelected = selectedCoupangApiStoreInfosValueContextHook?.coupangApiStoreInfos?.findIndex(storeInfo => storeInfo?.id === coupangApiStoreInfo?.id) > -1;

    return (
        <>
            <ScStoreList.Item
                className={`${isSelected ? 'selected' : ''}`}
                onClick={() => {
                    selectedCoupangApiStoreInfosActionsContextHook?.coupangApiStoreInfos?.setValue(prev => {
                        if (isSelected) {
                            return prev.filter(storeInfo => storeInfo?.id !== coupangApiStoreInfo?.id);
                        }
                        return [...prev, coupangApiStoreInfo];
                    });
                }}
            >
                <ScStoreList.ItemName>
                    {coupangApiStoreInfo?.storeName}
                </ScStoreList.ItemName>
                <ScStoreList.ItemEditButton
                    type='button'
                    onClick={(e) => { e.stopPropagation(); setEditModalOpen(true); }}
                >
                    수정
                </ScStoreList.ItemEditButton>
            </ScStoreList.Item>

            {editMoalOpen &&
                <EditCoupangApiStoreInfoModal
                    open={editMoalOpen}
                    onClose={() => setEditModalOpen(false)}
                    coupangApiStoreInfo={coupangApiStoreInfo}
                />
            }
        </>
    );
}